"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "prata-di-pordenone": {
    "68dd01f4": [{
      "hkey": "7eb6f7ce",
      "slug": "prata-di-pordenone",
      "name": "Prata di Pordenone",
      "primary": true,
      "skipSearch": false
    }],
    "le-monde": [{
      "hkey": "7eb6f7ce",
      "slug": "prata-di-pordenone",
      "name": "Prata di Pordenone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f76e664c": [{
      "hkey": "ec7fe5d5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "prata-di-sopra": [{
      "hkey": "ec7fe5d5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3997adbd": [{
      "hkey": "ec7fe5d5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "prata-di-sotto": [{
      "hkey": "ec7fe5d5",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prata-di-pordenone"
    }],
    "198a835a": [{
      "hkey": "4f6ba733",
      "slug": "puja-villanova",
      "name": "Puja-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "puja": [{
      "hkey": "4f6ba733",
      "slug": "puja-villanova",
      "name": "Puja-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5b7e6f6a": [{
      "hkey": "4f6ba733",
      "slug": "puja-villanova",
      "name": "Puja-Villanova",
      "primary": true,
      "skipSearch": false
    }],
    "villanova": [{
      "hkey": "4f6ba733",
      "slug": "puja-villanova",
      "name": "Puja-Villanova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "prata-di-pordenone"
    }]
  }
};
exports["default"] = _default;